/**
 * Read global application config from <meta> tags in the HTML layout.
 * Values are read once at import time and reused across all components.
 *
 * @returns {{ isAdmin: boolean, appVersion: string, anonymousAccess: boolean }}
 */
export function useAppConfig() {
  const isAdmin = document.querySelector('meta[name="admin"]')?.content === "true";
  const appVersion = document.querySelector('meta[name="app-version"]')?.content ?? "";
  const anonymousAccess = document.querySelector('meta[name="anonymous-access"]')?.content === "true";

  return { anonymousAccess, appVersion, isAdmin };
}
